import { URLS, createJurisdictionHeaders } from '@/data';
import { League, useLeagueKeys } from '@/feature/league-hub-sbk/hooks/use-league';
import { cacheControlHeader } from '@/utils/constants-platform-specific';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export type GetAllLeaguesResponse = {
    data: League[];
};

const getAllLeagues = async (): Promise<GetAllLeaguesResponse> => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/leagues`, {
        method: 'GET',
        headers: {
            ...createJurisdictionHeaders(),
            ...cacheControlHeader,
        },
    });
    const data = await response.json();
    if (!response.ok) {
        throw data;
    }
    return data;
};

export const useAllLeagues = () => {
    const queryClient = useQueryClient();
    const leagueKeys = useLeagueKeys();
    return useQuery({
        queryKey: leagueKeys.all,
        queryFn: () => getAllLeagues(),
        select: data => data.data,
        placeholderData: queryClient.getQueryData<GetAllLeaguesResponse>(leagueKeys.all),
    });
};
